import React, { useState, useEffect } from "react"
import { fetchTourAnalytics } from "../../../util/tour_events_api_util"

const styles = {
  filters: { display: "flex", flexWrap: "wrap", gap: "12px", alignItems: "flex-end", marginBottom: "24px" },
  btn: { margin: 0, height: "40px", padding: "0 20px", display: "inline-flex", alignItems: "center", justifyContent: "center" },
  card: { background: "#f7f8fc", borderRadius: 10, padding: "12px 10px", flex: "1 1 0", minWidth: 0 },
  cardLabel: { fontSize: 11, color: "#888" },
  cardValue: { fontSize: 22, fontWeight: 700, color: "#1B264F" },
  cards: { display: "flex", flexWrap: "nowrap", gap: "8px", marginBottom: "24px" },
  table: { width: "100%", borderCollapse: "collapse", marginTop: "8px" },
  th: { textAlign: "left", padding: "10px 12px", borderBottom: "2px solid #e2e2e2", fontWeight: 600 },
  td: { textAlign: "left", padding: "10px 12px", borderBottom: "1px solid #efefef" },
  link: { color: "#4E57AA", cursor: "pointer", fontSize: 13 },
  message: { padding: "16px 4px", color: "#777" },
}

const TourAnalytics = () => {
  const today = new Date().toISOString().split("T")[0]
  const thirtyDaysAgo = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split("T")[0]

  const [report, setReport] = useState([])
  const [loading, setLoading] = useState(true)
  const [startDate, setStartDate] = useState(thirtyDaysAgo)
  const [endDate, setEndDate] = useState(today)
  const [expandedProject, setExpandedProject] = useState(null)
  const [search, setSearch] = useState("")
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  useEffect(() => {
    const onResize = () => setWindowWidth(window.innerWidth)
    window.addEventListener("resize", onResize)
    return () => window.removeEventListener("resize", onResize)
  }, [])

  const load = () => {
    setLoading(true)
    fetchTourAnalytics(startDate, endDate).then(data => {
      setReport(data)
      setLoading(false)
    })
  }

  useEffect(() => { load() }, [])

  const filteredReport = search.length >= 2
    ? report.filter(r => r.address.toLowerCase().includes(search.toLowerCase()))
    : report

  const totalVisits = report.reduce((s, r) => s + r.visits, 0)
  const totalUnique = report.reduce((s, r) => s + r.unique_visits, 0)
  const totalForms = report.reduce((s, r) => s + r.contact_forms, 0)
  const overallConversion = totalUnique > 0 ? (totalForms / totalUnique * 100).toFixed(1) : 0

  return (
    <div className="settingsPreferencesGroupingDiv">
      <div className="settingsPreferences">
        <div className="settingsComponentHeading">Listing Website Analytics</div>

        <div className="settingsGroup">
          <div style={styles.filters}>
            <div className="settingsCompanyInput">
              <label className="formLabel">Start Date</label>
              <input type="date" className="formInput" value={startDate} onChange={e => setStartDate(e.target.value)} style={{ width: "100%" }} />
            </div>
            <div className="settingsCompanyInput">
              <label className="formLabel">End Date</label>
              <input type="date" className="formInput" value={endDate} onChange={e => setEndDate(e.target.value)} style={{ width: "100%" }} />
            </div>
            <button className="settingsButton" style={styles.btn} onClick={load}>Apply</button>
          </div>

          {/* <div>
            <input
              className="formInput"
              type="text"
              placeholder="Search by address..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{ maxWidth: 200 }}
            />
          </div> */}

          <div style={styles.cards}>
            {[
              { label: "Total Visits",     short: "Total Visits",  value: totalVisits },
              { label: "Unique Visits",    short: "Unique",        value: totalUnique },
              { label: "Form Submissions", short: "Form Subs",     value: totalForms },
              { label: "Conversion Rate",  short: "Conversion",    value: `${overallConversion}%` },
            ].map(({ label, short, value }) => (
              <div key={label} style={styles.card}>
                <div style={styles.cardLabel}>{windowWidth < 750 ? short : label}</div>
                <div style={styles.cardValue}>{value}</div>
              </div>
            ))}
          </div>

          {loading && <div style={styles.message}>Loading…</div>}

          {!loading && report.length > 0 && (
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Address</th>
                  <th style={styles.th}>Visits</th>
                  <th style={styles.th}>Unique</th>
                  <th style={styles.th}>Form Submissions</th>
                  <th style={styles.th}>Conversion</th>
                  <th style={styles.th}></th>
                </tr>
              </thead>
              <tbody>
                {filteredReport.map(row => (
                  <React.Fragment key={row.project_id}>
                    <tr>
                      <td style={styles.td}>{row.address}</td>
                      <td style={styles.td}>{row.visits}</td>
                      <td style={styles.td}>{row.unique_visits}</td>
                      <td style={styles.td}>{row.contact_forms}</td>
                      <td style={styles.td}>{row.conversion_rate}%</td>
                      <td style={styles.td}>
                        {row.submissions.length > 0 && (
                          <span
                            style={styles.link}
                            onClick={() => setExpandedProject(expandedProject === row.project_id ? null : row.project_id)}
                          >
                            {expandedProject === row.project_id ? "Hide" : "View"} submissions
                          </span>
                        )}
                      </td>
                    </tr>
                    {expandedProject === row.project_id && row.submissions.map((sub, i) => (
                      <tr key={i} style={{ background: "#f7f8fc" }}>
                        <td style={styles.td} colSpan={6}>
                          <div className="d-flex gap-4 flex-wrap" style={{ fontSize: 13, padding: "4px 0" }}>
                            <span><strong>Name:</strong> {sub.first_name} {sub.last_name}</span>
                            <span><strong>Email:</strong> {sub.email}</span>
                            {sub.phone && <span><strong>Phone:</strong> {sub.phone}</span>}
                            {sub.message && <span><strong>Message:</strong> {sub.message}</span>}
                            <span style={{ color: "#aaa" }}>{new Date(sub.submitted_at).toLocaleDateString()}</span>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  )
}

export default TourAnalytics
